import script from "./_edit-profile-info.vue?vue&type=script&setup=true&lang=js"
export * from "./_edit-profile-info.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__